import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getApproval,
  updateDocumentTrackingStatus,
} from "../../../actions/document.action";
import { userTypes } from "../../../utils/helpers/constants";
import AntTable from "./AntTable";
import { AiOutlineArrowLeft } from "react-icons/ai";
import TokenHelpers from "../../../utils/helpers/tokenHelper";
import { getAccountPathByName } from "../../../utils/helpers/getAccountTypeName";

export default function Body({ profile, documentList, docStatusLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [filterKey, setFilterKey] = useState("");
  const account_type = TokenHelpers.getFromStorage("account_type");
  const account_path = getAccountPathByName(account_type);

  const handleApproval = (document) => {
    var id = document.id;
    var name = document.documentType;
    const action = document.approved ? "disapproval" : "approval";
    const payload = { id, name, action };
    dispatch(getApproval(payload));
  };

  const handleStatusUpdate = (record, value) => {
    const payload = {
      documentProcessingId: record.id,
      status: value,
    };
    dispatch(updateDocumentTrackingStatus(payload));
  };

  const handleView = (item) => {
    history.push({
      pathname: `/dashboard${account_path}document-processing/${item.id}`,
      state: item,
    });
  };

  const handleSearch = (value) => {
    setFilterKey(value);
  };

  return (
    <div className="app-content hor-content">
      <div className="container mx-2 md:container md:mx-auto">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mt-2 cursor-pointer"
        />
        {[profile["userType"]] === userTypes.ROLE_USER ? null : (
          <div className="page-header">
            <div className="page-title">Document Processing</div>
          </div>
        )}
        <div className="p-2">
          <AntTable
            documentList={documentList}
            handleView={handleView}
            handleSearch={(value) => handleSearch(value)}
            handleApproval={handleApproval}
            statusState={docStatusLoading}
            handleStatusUpdate={(record, value) =>
              handleStatusUpdate(record, value)
            }
          />
        </div>
      </div>
    </div>
  );
}
